import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { API } from "../config";

export default function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      setMessage("All fields are required");
      return;
    }
    try {
      const res = await fetch(`${API}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setMessage(data.message || "Login failed"); return; }
      if (data.role.includes("(pending)")) { setMessage("Your account is waiting for approval"); return; }

      // Stockage persistant (survit aux fermetures de navigateur)
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("username", data.username);
      localStorage.setItem("userRole", data.roleForRouting);
      localStorage.setItem("adminHospitalId", data.hospital_id);
      localStorage.setItem("loginTime", data.loginTime);
      // Stockage de session (filet de sécurité pour l'onglet courant)
      sessionStorage.setItem("userId",   String(data.userId));
      sessionStorage.setItem("username", data.username);
      sessionStorage.setItem("userRole", data.roleForRouting);

      switch (data.roleForRouting) {
        case "super-admin":   navigate("/super-admin-dashboard"); break;
        case "admin":         navigate("/hospital-admin-dashboard"); break;
        case "doctor":        navigate("/doctor-dashboard"); break;
        case "medical_stuff": navigate("/medical-stuff-dashboard"); break;
        default:              navigate("/home");
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error");
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;700;800&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap');
        .signin-body { font-family: 'Manrope', sans-serif; }
        input:focus {
          border-color: #137fec;
          box-shadow: 0 0 0 3px rgba(19,127,236,0.15);
          outline: none;
        }
      `}</style>

      <div className="signin-body h-screen flex flex-col md:flex-row w-full overflow-hidden bg-[#f6f7f8]">
        {/* LEFT SIDE */}
        <div className="hidden md:flex md:w-1/2 lg:w-5/12 relative flex-col justify-end p-10 overflow-hidden bg-slate-900">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 z-10" style={{ background: "linear-gradient(to top, rgba(19,127,236,0.9), rgba(19,127,236,0.4))" }} />
            <div className="w-full h-full bg-cover bg-center" style={{ backgroundImage: `url("https://lh3.googleusercontent.com/aida-public/AB6AXuAPX15_v6jEpml0qNYZezaglmy0MzYMZFbgx8eHjLJJcDsXkj7QUocfIlIA-0BEjHe0yHGAiTrlPRaAdA11Z7QxewObRgua3b-le82BvlBU7qs0v98G2c3W-oZuskrA1OZDp_hQkS2J40l6sTZcwtRNpFsofZXV0VlSpflFNalv_EK-e7K2eOSoSj35Q7B9vHqsv9nMuttnvXQz3mainKhXEBFAJCDeCS3exihKDdPzW8cRtvMnP6lPdJruxpccbSbWHSJ-6z7pQjbg")` }} />
          </div>
          <div className="relative z-20 text-white">
            <div className="flex items-center gap-3 mb-3">
              <span className="material-symbols-outlined" style={{ fontSize: 36 }}>local_hospital</span>
              <h1 className="text-4xl font-black tracking-tight">CareTech Cloud</h1>
            </div>
            <p className="text-lg font-medium opacity-90 max-w-md">
              Remote medical monitoring platform for patient care at a distance
            </p>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex-1 flex items-center justify-center px-6 md:px-12 lg:px-16 bg-white overflow-y-auto">
          <div className="w-full max-w-md flex flex-col gap-4 py-8">

            {/* Back to Home */}
            <button
              onClick={() => navigate("/home")}
              className="flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800 transition-colors self-start"
            >
              <span className="material-symbols-outlined" style={{ fontSize: 18 }}>arrow_back</span>
              Back to Home
            </button>

            <div className="text-center flex flex-col items-center gap-3">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "rgba(19,127,236,0.1)", color: "#137fec" }}>
                <span className="material-symbols-outlined" style={{ fontSize: 28 }}>lock</span>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-slate-900">Welcome Back</h2>
                <p className="text-slate-500 text-sm">Sign in to your CareTech account.</p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-1">
                <label className="text-sm font-semibold text-slate-800">Email Address</label>
                <input
                  type="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                  className="w-full h-11 px-4 rounded-xl border border-slate-200 bg-slate-50 transition-all"
                />
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-sm font-semibold text-slate-800">Password</label>
                <input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                  className="w-full h-11 px-4 rounded-xl border border-slate-200 bg-slate-50 transition-all"
                />
              </div>

              <button
                onClick={handleLogin}
                className="w-full h-11 text-white font-bold rounded-xl"
                style={{ background: "#137fec" }}
              >
                Sign In
              </button>

              {message && <p className="text-center text-red-500 text-sm">{message}</p>}
            </div>

            <p className="text-center text-sm text-slate-600">
              Forgot password?{" "}
              <button
                onClick={() => navigate("/email-verification")}
                className="font-bold hover:underline"
                style={{ color: "#137fec" }}
              >
                Reset Password
              </button>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
